import React, { useEffect, useState } from 'react';
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Input,
  Switch,
  Button,
  useToast,
  Flex,
} from '@chakra-ui/react';
import CompanyConfigApi from 'api/companyconfig';
import PageError from 'components/nopermission/PageError';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import { Modules } from 'config/constant';
import { usePermissions } from 'contexts/PermissionContext';
import { isValidUUID } from 'utils/fetchUtils';

const CompanyConfig = (props) => {
  const [loading, setLoading] = useState(true);
  const [companies, setCompanies] = useState([]);
  const [isDataChanged, setIsDataChanged] = useState(false);
  const toast = useToast();
  const [fetchCompanyConfigError, setFetchCompanyConfigError] = useState(false);
  const companyId = IdFromUrl(window.location.href);
  function IdFromUrl(url) {
    // Split the URL by slashes
    const parts = url.split('/');

    // The last part of the URL is the ID
    const id = parts[parts.length - 1];

    return id;
  }
  const { getPermissionsForModule } = usePermissions();
  const [permission, setPermissions] = useState(null);

  const fetchCompanyData = async () => {
    if (!isValidUUID(companyId)) {
      setFetchCompanyConfigError(true);
      return;
    }
    try {
      setLoading(true);
      let response = await CompanyConfigApi.getById(companyId);
      response = response.data;
      setLoading(false);
      if (response.status_code === 200) {
        setFetchCompanyConfigError(false);
        console.log('response', response);
        setCompanies(response.data);
      } else {
        setFetchCompanyConfigError(true);
        setCompanies([]);
      }
    } catch (err) {
      setFetchCompanyConfigError(true);
      console.error(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    const permission = getPermissionsForModule([Modules.Company]);
    setPermissions(permission);
  }, [companyId]);

  useEffect(() => {
    if (hasAllPermissions) {
      fetchCompanyData();
    }
  }, [permission]);

  const handleInputChange = (index, field, value) => {
    const updatedCompanies = companies.map((company, i) =>
      i === index ? { ...company, [field]: value } : company
    );
    setCompanies(updatedCompanies);
    setIsDataChanged(true);
  };

  const hasAllPermissions =
    permission?.read &&
    permission?.create &&
    permission?.update &&
    permission?.delete;

  const handleToggleChange = (index) => {
    const updatedCompanies = companies.map((company, i) =>
      i === index ? { ...company, is_active: !company.is_active } : company
    );
    setCompanies(updatedCompanies);
    setIsDataChanged(true);
  };

  const handleAddRow = () => {
    setCompanies([...companies, { name: '', location: '', is_active: false }]);
  };

  const handleSave = async () => {
    const filteredCompanies = companies.filter(
      (company) => company.name && company.location
    );

    try {
      await CompanyConfigApi.saveAll(filteredCompanies, companyId);
      toast({
        title: 'Company configurations have been saved successfully.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      setIsDataChanged(false);
    } catch (error) {
      console.error(error);
      toast({
        title: 'Failed to save company configurations. Please try again.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  if (!hasAllPermissions) {
    return <NoPermissionsMessage module={Modules.Company} />;
  }

  if (!hasAllPermissions) {
    return <NoPermissionsMessage module={Modules.Company} />;
  }

  return fetchCompanyConfigError ? (
    <PageError />
  ) : (
    <Box p={5}>
      {loading ? (
        <Box>Loading...</Box>
      ) : (
        <>
          <Table
            variant='striped'
            colorScheme='gray'>
            <Thead>
              <Tr>
                <Th>Name</Th>
                <Th>Location</Th>
                <Th>Active</Th>
              </Tr>
            </Thead>
            <Tbody>
              {companies.map((company, index) => (
                <Tr key={company.id}>
                  <Td>
                    <Input
                      value={company.name}
                      onChange={(e) =>
                        handleInputChange(index, 'name', e.target.value)
                      }
                    />
                  </Td>
                  <Td>
                    <Input
                      value={company.location}
                      onChange={(e) =>
                        handleInputChange(index, 'location', e.target.value)
                      }
                    />
                  </Td>
                  <Td>
                    <Switch
                      isChecked={company.is_active}
                      onChange={() => handleToggleChange(index)}
                    />
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
          <Flex
            mt={4}
            justify='space-between'>
            <Button
              colorScheme='blue'
              onClick={handleAddRow}
              disabled={!hasAllPermissions}>
              Add Row
            </Button>
            {isDataChanged && (
              <Button
                colorScheme='green'
                onClick={handleSave}
                disabled={!hasAllPermissions}>
                Save
              </Button>
            )}
          </Flex>
        </>
      )}
    </Box>
  );
};

export default CompanyConfig;
